<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">展会管理</el-breadcrumb-item>
      <el-breadcrumb-item>展会列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->
        <el-form :inline="true" label-position="right" label-width="100px" ref="formInline" :model="formInline" class="user-search">
          <el-form-item label="展会名称" prop="title">
            <el-input size="small" style="width: 200px;" v-model="formInline.exhibitionName" placeholder="请输入标题"></el-input>
          </el-form-item>

          <el-form-item label="请选择状态" prop="status">
            <el-select v-model="formInline.status" placeholder="请选择状态">
              <el-option label="开启中" :value = 0></el-option>
              <el-option label="已禁用" :value = 1 ></el-option>
            </el-select>
          </el-form-item>


          <el-form-item label="时间" prop="baseForm">
            <el-date-picker style="width: 370px;"
                            v-model.trim="baseForm"
                            type="datetimerange"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            range-separator="-"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间">
            </el-date-picker>
          </el-form-item>


          <el-form-item>
            <el-button size="small" type="primary"  @click="resetFrom" >重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="tableList" >搜索</el-button>
            <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
          </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"
                  highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"  style="width: 100%;">

          <template style="width: 100%" >
            <el-table-column prop="exhibitionName" label="展会名称" align="center"></el-table-column>


            <el-table-column prop="image" label="展会图片" align="center">
              <template slot-scope="scope">
                <el-popover placement="top-start" trigger="hover">
                  <!--trigger属性值：hover、click、focus 和 manual-->
                  <a :href="scope.row.image" target="_blank" title="查看最大化图片"><img :src="scope.row.image" style="width: 300px;height: 300px" /></a>
                  <img slot="reference" :src="scope.row.image" style="width: 50px;height: 50px; cursor:pointer" />
                </el-popover>
              </template>
            </el-table-column>

            <el-table-column prop="stadiumName" label="所属场馆" align="center"></el-table-column>

            <el-table-column prop="sponsor" label="主办方" align="center"></el-table-column>
            <el-table-column prop="address" label="展会地址" align="center"></el-table-column>
            <el-table-column prop="sort" label="展会顺序" align="center"></el-table-column>

            <el-table-column align="center"  prop="status" label="状态" width="170px" >
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.status"
                  active-text="开启中"
                  inactive-text="已禁用"
                  :active-value="0"
                  :inactive-value="1"
                  @change="turn(scope.row)">
                </el-switch>
              </template>
            </el-table-column>

            <el-table-column prop="time" label="布展时间" align="center">
              <template slot-scope="scope">
                <div> {{scope.row.arrBegin|timestampToTime}}--{{scope.row.arrEnd|timestampToTime}}</div>
              </template>
            </el-table-column>

            <el-table-column prop="time" label="发布时间" align="center">
              <template slot-scope="scope">
                <div> {{scope.row.beginTime|timestampToTime}}--{{scope.row.endTime|timestampToTime}}</div>
              </template>
            </el-table-column>


            <el-table-column  label="操作" align="center" fixed="right" width="200px">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="handleDel(scope.row.id)">删除</el-button>
                <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click='closeDialog("edit")' :close-on-click-modal="false">
          <el-form label-width="140px" :model="editForm" ref="editForm"  :rules="rules">

            <el-form-item label="展会名称" prop="exhibitionName">
              <el-input size="small" v-model="editForm.exhibitionName"  auto-complete="off" placeholder="请输入展会名称"></el-input>
            </el-form-item>

            <el-form-item label="展会图片" prop="image">
              <el-upload
                class="avatar-uploader"
                :action="this.host+'/fileUpload/ossBatch'"
                :show-file-list="false"
                :on-success="handleAvatarSuccessOne"
                :before-upload="beforeAvatarUpload">
                <img v-if="editForm.image" :src="editForm.image" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">建议上传尺寸 200 * 200</div>
              </el-upload>
            </el-form-item>

            <el-form-item label="所属场馆" prop="stadiumId">
              <el-checkbox-group v-model="editForm.stadiumId">
                <el-checkbox  v-for="(operate, index) in staList"
                              :label="operate.id.toString()">
                  {{operate.name}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>


<!--            <el-form-item label="示意图" prop="banner">-->
<!--              <el-upload-->
<!--                list-type="picture-card"-->
<!--                :action="this.host+'/fileUpload/ossBatch'"-->
<!--                :file-list="bnImages"-->
<!--                :on-success="handleBannerAvatarSuccess"-->
<!--                :before-upload="beforeAvatarUpload"-->
<!--                :on-remove="handleBannerRemove"-->
<!--                :limit="3">-->
<!--                <i class="el-icon-plus"></i>-->
<!--                <div slot="tip" class="el-upload__tip">请按选择的场馆顺序上传图片。图片大小不超过2MB。建议宽度1125*1125。数量不超过9张。</div>-->
<!--              </el-upload>-->
<!--            </el-form-item>-->

            <el-form-item label="主办方" prop="sponsor">
              <el-input size="small" v-model="editForm.sponsor" auto-complete="off" placeholder="请输入主办方"></el-input>
            </el-form-item>

            <el-form-item label="展会地址" prop="address">
              <el-input size="small" v-model="editForm.address" auto-complete="off" placeholder="请输入展会地址"></el-input>
            </el-form-item>

            <el-form-item label="布展时间" prop="arrBegin">
              <el-date-picker
                v-model="arrForm"
                type="datetimerange"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="-"
                start-placeholder="开始时间"
                end-placeholder="结束时间">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="展会时间" prop="beginTime">
              <el-date-picker
                v-model="baseForm"
                type="datetimerange"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="-"
                start-placeholder="开始时间"
                end-placeholder="结束时间">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="展会排序" prop="sort">
              <el-input size="small" type="number" v-model="editForm.sort" auto-complete="off" placeholder="请输入展会排序"></el-input>
            </el-form-item>

            <el-form-item label="是否同步展会商品" prop="shop">
              <el-radio v-model="editForm.shop" label=0>否</el-radio>
              <el-radio v-model="editForm.shop" label=1>是</el-radio>
            </el-form-item>


            <el-form-item label="初始化分类" prop="fenleiList" v-if="editForm.id == '' && editForm.shop == 0">
              <el-checkbox-group v-model="editForm.fenleiList">
                <el-checkbox  v-for="(operate, index) in fenList"
                              :label="operate.value">
                  {{operate.name}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="同步展会商品" prop="isCopyExhId" v-if="!editForm.id && editForm.shop == 1">
              <el-select v-model="editForm.isCopyExhId" placeholder="请选择">
                <el-option
                  v-for="item in exhList"
                  :key="item.id"
                  :label="item.exhibitionName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>


          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
            <el-button size="small" type="primary" class="title"  :disabled="isDisabled" @click="submitForm('editForm')">保存</el-button>
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import {qryExhibitionList, upStatus, upExhibition, addExhibition, upReservedStatus, delZh} from '../../api/platformApi'
  import {qryStadiumList} from '../../api/courseApi'
  import Pagination from '../../components/Pagination'
  import {timestampToTime,parseTime} from "../../utils/util";
export default {
  name: "medalList",
  data() {
    return {
        isDisabled: false,
        loading: false, //是显示加载
        title:'添加',
        editFormVisible:false,
        formInline:{
          exhibitionName:'',
          status:'',
          page:1,
          pageSize:10
        },
        // rules表单验证
        rules: {
          exhibitionName: [
            { required: true, message: '展会名称不能为空', trigger: 'blur' }
          ],
          sponsor: [
            { required: true, message: '主办方', trigger: 'blur' }
          ],
          stadiumId: [
            { required: true, message: '请选择场馆', trigger: 'blur' }
          ],
        },
        listData:[],
        baseForm:[],
        arrForm:[],
        staList:[],
        bnImages:[],
        bnImageUrlList:[],
        exhList:[],
        editForm:{
          id:'',
          exhibitionName:'',
          stadiumId:[],
          beginTime:'',
          endTime:'',
          sponsor:'',
          image:'',
          address:'',
          banner:'',
          sort:'',
          arrBegin:'',
          arrEnd:'',
          isCopyExhId:'',
          fenleiList:[],
        },
        fenList:[{"name":"场馆租赁","value":"1"},
          {"name":"搭建服务","value":"2"},
          {"name":"餐饮服务","value":"3"},
          {"name":"安保及清运","value":"4"},
          {"name":"配套租赁","value":"5"},
          {"name":"会务服务","value":"6"},
          {"name":"网络服务","value":"7"},
          {"name":"车辆及运输","value":"8"}],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
    }
  },
  mounted() {
    this.tableList();
  },
  methods:{
    tableList(){
      if (this.baseForm != ''&& this.baseForm != null) {
        // 开始时间
        this.formInline.beginTime = this.$moment(`${this.baseForm[0]}`)
        // 结束时间
        this.formInline.endTime = this.$moment(`${this.baseForm[1]}`)
      } else {
        // 删除开始时间
        delete this.formInline.beginTime;
        // 删除结束时间
        delete this.formInline.endTime;
      }
      this.loading = true;
      qryExhibitionList(this.formInline).then(res => {
        this.listData = res.data.list;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.pageSize;
        this.pageparm.total = res.data.total;
        this.loading = false;
      })

      qryStadiumList({pageSize:1000}).then(res => {
        this.staList = res.data;
      })


      qryExhibitionList({page:1,pageSize:10000}).then(res => {
        this.exhList = res.data.list;
      })
    },

    resetFrom(){
      this.formInline.exhibitionName = '';
      this.formInline.status = '';
      this.baseForm = [];
      this.formInline.page = 1;
      this.formInline.pageSize = 10;
    },

    closeDialog(){
      this.$refs['editForm'].resetFields();
      this.baseForm =[]
      this.bnImages = []
      this.bnImageUrlList = []
      this.editFormVisible = false;
    },

    handleDel(id) {
      this.$confirm('确认要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.editForm.id = id;
        delZh({id: id}).then(res =>{
          if (res.code==1) {
            this.editResdVisible = false
            this.$message({
              type: 'success',
              message: '数据保存成功！'
            })
            this.tableList(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
          this.isDisabled = false;
        }).catch(err => {
          this.editResdVisible = false
          this.$message.error('保存失败，请稍后再试！')
          this.isDisabled = false;
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });

    },


    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.exhibitionName = row.exhibitionName
        this.editForm.sponsor=row.sponsor
        this.editForm.image=row.image
        this.editForm.address=row.address
        this.editForm.banner=row.banner
        this.editForm.sort=row.sort
        this.editForm.arrTime=row.arrTime
        this.editForm.stadiumId=row.stadiumId.split(",")
        this.baseForm = [this.$moment(row.beginTime).format("YYYY-MM-DD HH:mm:ss"),this.$moment(row.endTime).format("YYYY-MM-DD HH:mm:ss")]
        this.arrForm = [this.$moment(row.arrBegin).format("YYYY-MM-DD HH:mm:ss"),this.$moment(row.arrEnd).format("YYYY-MM-DD HH:mm:ss")]
        if (this.editForm.banner){
          let strings = this.editForm.banner.split(",");
          for(let i=0;i<strings.length;i++){
            this.bnImages.push({url:strings[i]});
          }
        }else {
          this.bnImages = []
          this.bnImageUrlList = []
        }
      } else {
        this.title = '添加'
        this.editForm.id = ''
        this.editForm.exhibitionName = ''
        this.editForm.stadiumId=''
        this.baseForm=''
        this.editForm.sponsor=''
        this.editForm.image=''
        this.editForm.address=''
        this.editForm.banner=''
        this.editForm.sort=''
        this.editForm.arrTime=''
        this.baseForm =[]
        this.arrForm =[]
        this.editForm.stadiumId =[]
        this.editForm.fenleiList =[]
        this.bnImages = []
        this.bnImageUrlList = []
      }
    },

    turn(row) {
      var data={
        id:row.id,
        status:row.status
      }
      upStatus(data).then(res =>{
        if (res.code==1) {
          this.$message({
            type: 'success',
            message: '数据保存成功！'
          })
          this.tableList(this.formInline)
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      }).catch(err => {
        this.$message.error('保存失败，请稍后再试！')
      })
    },

    // 编辑、添加提交方法
    submitForm(editData) {
      // this.isDisabled = true;
      if (this.baseForm != ''&& this.baseForm != null) {
        // 开始时间
        this.editForm.beginTime = this.$moment(`${this.baseForm[0]}`)
        // 结束时间
        this.editForm.endTime = this.$moment(`${this.baseForm[1]}`)
      } else {
        // 删除开始时间
        delete this.editForm.beginTime;
        // 删除结束时间
        delete this.editForm.endTime;
      }



      if (this.arrForm != ''&& this.arrForm != null) {
        // 开始时间
        this.editForm.arrBegin = this.$moment(`${this.arrForm[0]}`)
        // 结束时间
        this.editForm.arrEnd = this.$moment(`${this.arrForm[1]}`)
      } else {
        // 删除开始时间
        delete this.editForm.arrBegin;
        // 删除结束时间
        delete this.editForm.arrEnd;
      }
      // let imgs = [];
      // for(let i in this.bnImageUrlList){
      //   if(this.bnImageUrlList[i]){
      //     if (this.editForm.banner){
      //       imgs.push(this.editForm.banner);
      //     }
      //     imgs.push(this.bnImageUrlList[i]);
      //   }
      // }
      // if(imgs.length>0){
      //   this.editForm.banner = imgs.join(",");
      // }
      // if (this.editForm.banner == null){
      //   this.$message.error('保存失败，请按照顺序上传示意图！')
      //   return
      // }

      this.editForm.stadiumId= this.editForm.stadiumId.toString()
      this.editForm.fenleiList= this.editForm.fenleiList.toString()
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.id!=''){
            upExhibition(this.editForm).then(res =>{
              if (res.code==1) {
                this.editFormVisible = false
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.baseForm = [];

                this.editForm.banner=''
                this.bnImages = []
                this.bnImageUrlList = []
                this.tableList(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
              this.isDisabled = false;
            }).catch(err => {
              this.editFormVisible = false
              this.$message.error('保存失败，请稍后再试！')
              this.isDisabled = false;
            })
          }else{
            addExhibition(this.editForm)
              .then(res => {
                if (res.code==1) {
                  this.editFormVisible = false
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                  this.baseForm = [];

                  this.editForm.banner=''
                  this.bnImages = []
                  this.bnImageUrlList = []
                  this.tableList(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
                this.isDisabled = false;
              })
              .catch(err => {
                this.editFormVisible = false
                this.$message.error('保存失败，请稍后再试！')
                this.isDisabled = false;
              })
          }
          // 请求方法
        } else {
          this.isDisabled = false;
          return false
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.tableList();
    },
    handleAvatarSuccessOne(res) {
      this.editForm.image = res.data;
    },

    handleBannerAvatarSuccess(res, file) {
      // this.editForm.banner = res.data;
      this.bnImageUrlList[file.uid] = res.data;
    },

    beforeAvatarUpload(file) {
      //const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      /*if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }*/
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },

    handleBannerRemove(file, fileList) {
      if(this.bnImageUrlList[file.uid]){
        this.bnImageUrlList[file.uid] = null;
      }else{
        let j = 0;
        for(let i in this.bnImageUrlList){
          if(this.bnImageUrlList[i]==file.url){
            this.bnImageUrlList[i] = null;
            this.bnImageUrlList.splice(j,1);
          }
          j++;
        }
      }
    }

  },
  //分页组件
  components: {
    Pagination
  }
}
</script>

<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .redItem.el-form-item__label{
    color: #00ff80;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/platform/medalList.vue